// loopingText.js //
import {isOverflowed, debounce} from '../helpers/helpers.js'
/* FUTURE: Start & stop animation only if in view. */
import { gsap } from "gsap";

export default class OverflowScrollLoop {
  constructor(els){
      this.bindAll();

      els = (typeof els !== 'undefined') ?  els : document.querySelectorAll('[data-overflow-scroll="tags"]');
      this.els = document.querySelectorAll('[data-overflow-scroll="tags"]');

      if (!this.els.length) return;

      this.timelines = []

      this.cloneItems();
      this.initEvents();
  }
  bindAll() {
      ['handleMouseEnter', 'handleMouseLeave', 'resize'].
      forEach(fn => this[fn] = this[fn].bind(this));
  }  
  // Create clones of the text & append them to container
  cloneItems() {
      // let self = this;
      let key = 0;

      this.els.forEach((item) => {
        const parentSelector = item;
        const innerContent = parentSelector.children[0]

          /* on intial execution, if it's overflowed */
          if (isOverflowed(item)) {
              innerContent.innerHTML += ",&nbsp";
              const clone = item.innerHTML;
              parentSelector.insertAdjacentHTML('beforeend', clone);
              parentSelector.setAttribute('data-overflow-scroll-key', key);
              this.buildTimelines(parentSelector, key);
              key++
          }

      })

  }

  buildTimelines(el, index) {
      const tl = gsap.timeline( {repeat: -1} );
      const elWidth = el.clientWidth / 2;

      tl.to(el, {
        // x: -elWidth,
        xPercent: -50,
        duration: 6, 
        ease: 'none'
      })
      this.timelines.push({
        tl: tl,
        key: index
      }); 
  }
  killTimelines(reset) {
    let self = this;

    // create a promise, and return true once animation is resolved
    let promise = new Promise(function(resolve, reject) {

      self.timelines.forEach((obj) => {
        gsap
        .to(obj.tl, 1.5, {
          progress: 0,
          onComplete: function() {
            obj.tl.kill(true);
            resolve();
          }
        })
      })

    })

    // once animation is complete, kill that motherfucker.
    Promise.all([promise]).then((clone)=>{
      this.timelines.length = [];
    });

  }
  handleMouseEnter(event) {
    let text = event.target.closest('[data-overflow-scroll="tags"]');
    let key = text.getAttribute('data-overflow-scroll-key');
    let self = this;

    if (text) {
        pause();
    }

    function pause() {
        gsap.to(self.timelines[key].tl, .5, {
          timeScale:0,
          overwrite:true
        });
    }

  }  

  handleMouseLeave(event) {
    let text = event.target.closest('[data-overflow-scroll="tags"]');
    let key = text.getAttribute('data-overflow-scroll-key');
    let self = this;

    if (text) {
        //calls myFunction() after 1 second and passes 2 parameters:
        gsap.delayedCall(.2, play);
        // play();
    }

    function play() {
        gsap.to(self.timelines[key].tl, 1, {
          timeScale:1,
        });
    }  

  }

  initEvents() {

    // document.addEventListener('mouseover', this.handleMouseEnter, true);
    this.els.forEach((el, index) => {
      // add the eventListeners
      el.addEventListener("mouseenter", this.handleMouseEnter);
      el.addEventListener("mouseleave", this.handleMouseLeave);
    })

    // this.debounce = debounce(this.resize, 500);
    // window.addEventListener('resize', () => this.debounce());

  }
  removeEvents() {

    this.els.forEach((el) => {
      el.removeEventListener("mouseenter", this.handleMouseEnter);
      el.removeEventListener("mouseleave", this.handleMouseLeave);
    })

    // window.removeEventListener('resize', () => this.debounce());

  }

  resize() {
    // this.unmount();
    console.log('resize is complete!');

  }

  destroy() {
    this.killTimelines();
    this.removeEvents();
    console.log('unmounted!');
  }

}
